import * as breeding from './breeding-main.js';

export default {
    breeding,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Breeding
    window.EQLAPP.BREEDING = window.EQLAPP.BREEDING || {};
    Object.entries(breeding).forEach(([key, value]) => {
        window.EQLAPP.BREEDING[key] = value;
    });

}